import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/writeLetters",
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("@/views/loading.vue"),
  },
  {
    path: "/userLoading",
    name: "userLoading",
    component: () => import("@/views/userLoading.vue"),
  },
  {
    path: "/writeLetters",
    name: "writeLetters",
    component: () => import("@/views/writeLetters/index.vue"),
  },
  {
    path: "/details",
    name: "details",
    component: () => import("@/views/writeLetters/details.vue"),
  },
  {
    path: "/detailsMoblie",
    name: "detailsMoblie",
    component: () => import("@/views/writeLetters/detailsMoblie.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error.vue"),
  },

  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index.vue"),
    children: [],
  },
  // 暂停写信通知页
  {
    path: "/blank",
    name: "blank",
    component: () => import("@/views/blank.vue"),
    children: [],
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
// 路由守卫
const isShow = false;// true 暂停写信
router.beforeEach((to, from, next) => {
  if (to.path === "/blank") {
    next();
    return;
  }
  if (isShow) {
    next("/blank");
  } else {
    next();
  }
});
export default router;
